<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <Spin v-if="isLoading"></Spin>
    <CheckboxGroup
      class="zpa-row middle"
      v-if="!isLoading"
      :value="renderValue"
      @on-change="onInputChange"
    >
      <Checkbox
        v-for="v in renderValues"
        :key="getValue(v)"
        :label="getValue(v)"
        :disabled="$readonly"
      >{{getText(v)}}</Checkbox>
    </CheckboxGroup>
  </zpa-form-item>
</template>

<script>
import inputMixin from "./mixins/input";
import queryMixin from "./mixins/query";
import valueTextMixin from "./mixins/value-text";
import stringifyMixin from "./mixins/stringify";

export default {
  name: "zpaCheckboxGroup",

  mixins: [inputMixin, queryMixin, valueTextMixin, stringifyMixin],

  props: {
    value: [String, Array],

    multiple:{
      type: Boolean,
      default: true
    },

    values: Array,

    type: {
      type: String,
      default: 'object'
    }

  },

  data() {
    return {
      disabledGroup: null
    };
  },

  mounted() {
    if (this.renderValue instanceof Array) {} else {
      this.renderValue = []
    }
  }
};
</script>
<style>
  .zpa-row.middle.ivu-checkbox-group.ivu-checkbox-default {
    display: flex;
    /*    align-items: flex-start;*/
    flex-wrap: wrap;
  }
  .ivu-checkbox-wrapper {
    cursor: pointer;
    font-size: 12px;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 5px;
  }
</style>
